/**
 * Dealer Section Component
 *
 * @package
 */

import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import DealerMap from './DealerMap';
import DealerList from './DealerList';
import EnquiryModal from './EnquiryModal';

const DealerSection = ( { vehicleBrand, selectedBaseModel, selectedProducts, vehicleConfigId, shareableCode, vatMode, quantities } ) => {
	const [ selectedDealer, setSelectedDealer ] = useState( null );
	const [ isModalOpen, setIsModalOpen ] = useState( false );
	const [ showSuccess, setShowSuccess ] = useState( false );

	const handleDealerSelect = dealerId => {
		setSelectedDealer( dealerId );
	};

	const handleMarkerClick = dealerId => {
		// Scroll to list item when marker is clicked.
		// The DealerList component will handle the scrolling via useEffect.
		setSelectedDealer( dealerId );
	};

	// ID comes from the click: the caller selects and opens in one tick, so reading
	// selectedDealer here would see the pre-click value.
	const handleOpenModal = ( dealerId = null ) => {
		const dealer = dealerId || selectedDealer;
		if ( ! dealer ) {
			return;
		}

		setSelectedDealer( dealer );
		setIsModalOpen( true );
	};

	const handleCloseModal = () => {
		setIsModalOpen( false );
	};

	const handleEnquirySuccess = () => {
		setShowSuccess( true );
		setTimeout( () => {
			setShowSuccess( false );
		}, 5000 );
	};

	return (
		<section className="configurator-dealers" id="configurator-dealers" aria-labelledby="dealers-heading">
			<div className="configurator-dealers-header">
				<div className="configurator-dealers-header-label">{ __( 'Contact Us', 'at-vehicle-configurator' ) }</div>
				<h2 id="dealers-heading">{ __( 'Find a Dealer', 'at-vehicle-configurator' ) }</h2>
			</div>
			<div className="configurator-dealers-container">
				<div className="configurator-dealers-map-list">
					<DealerMap
						vehicleBrand={ vehicleBrand }
						selectedDealer={ selectedDealer }
						onDealerSelect={ handleDealerSelect }
						onMarkerClick={ handleMarkerClick }
					/>
					<DealerList
						vehicleBrand={ vehicleBrand }
						selectedDealer={ selectedDealer }
						onDealerSelect={ handleDealerSelect }
						onOpenModal={ handleOpenModal }
					/>
				</div>
				{ showSuccess && (
					<div className="configurator-enquiry-success" role="status" aria-live="polite">
						{ __( 'Enquiry sent successfully! The dealer will contact you soon.', 'at-vehicle-configurator' ) }
					</div>
				) }
			</div>
			<EnquiryModal
				isOpen={ isModalOpen }
				onClose={ handleCloseModal }
				selectedDealer={ selectedDealer }
				vehicleConfigId={ vehicleConfigId }
				selectedBaseModel={ selectedBaseModel }
				selectedProducts={ selectedProducts }
				shareableCode={ shareableCode }
				vatMode={ vatMode }
				quantities={ quantities }
				onSuccess={ handleEnquirySuccess }
			/>
		</section>
	);
};

export default DealerSection;
